import styled from "styled-components";
const Container = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 12px 28px;
  background: var(--filter-bar-bg);
  @media (max-width: 850px) {
    &.display {
      display: none;
    }
  }
`;
const TagsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 15px;
  flex-wrap: wrap;
  @media (max-width: 850px) {
    padding: 0;
    .display {
      display: none;
    }
  }
`;
const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  flex-wrap: wrap;
  row-gap: 10px;
  .fleet-car-msg {
    right: 0;
    margin-right: 42%;
    margin-top: 5.5rem;
    padding: 0;
    z-index: 1;
    &.fleet_car {
      z-index: 9999;
    }
    .inner-wrapper {
      background-color: #000000e0;
      width: 100%;
    }
  }
  .IconWrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    button {
      border: none;
      background: transparent;
      padding: 0;
    }
  }
  .label-wrapper {
    display: flex;
    align-items: center;
    border-right: 1px solid #cdcfd0;
    padding: 0 15px;
    gap: 15px;
    :first-child {
      padding-left: 0;
    }
    :last-child {
      border: none;
    }
    label {
      font-size: 13px;
      line-height: 16px;
      white-space: nowrap;
      color: var(--theme-text);
    }
    .MuiSelect-select {
      font-size: 13px;
      padding: 3.5px 14px;
      text-transform: capitalize;
    }

    .MuiOutlinedInput-root {
      background: #ffffff;
      border-radius: 6px;
    }
    .MuiFormControl-root {
      margin: 0;
    }
  }
  @media (max-width: 850px) {
    flex-direction: column;
    display: inline-flex;
    align-items: flex-end;
    flex: unset;
    .fleet-car-msg {
      .inner-wrapper {
        position: relative;
      }
    }
    .label-wrapper {
      border: none;
      padding: 0;
    }
    .display {
      display: none;
    }
  }
`;

const Tag = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  border: 1px solid var(--filter-bar-btn-border);
  border-radius: 30px;
  background-color: transparent;
  min-height: 30px;
  color: var(--theme-text);
  min-width: 31px;
  justify-content: center;
  @media (max-width: 1136px) {
    gap: 0;
    border-radius: 6px;
    span {
      display: none;
    }
  }
`;

const SettingIconWrapper = styled.button`
  background: transparent;
  border: 1px solid #fff;
  border-radius: 6px;
  width: 40px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const KeyIconWrapper = styled.span`
  position: relative;
  .MuiIconButton-root {
    padding: 0;
  }
`;
const KeyPopup = styled.div`
  position: absolute;
  background: var(--theme-background);
  color: var(--theme-text);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  width: 183px;
  height: 58px;
  font-size: 16px;
  line-height: 150.5%;
  display: flex;
  align-items: center;
  justify-content: center;
  right: calc(50% - 88px);
  top: 41px;
  z-index: 1;
  span {
    width: 15px;
    height: 15px;
    position: absolute;
    top: 0px;
    background: var(--theme-background);
    transform: rotate(45deg);
    top: -6px;
  }
  @media (max-width:850px) {
    right: 0;
    span {
      right: 8px;
    }
  }
`;

const ChangeSettingModalWrapper = styled.div`
  padding: 17px 18px;
  /* box-sizing: revert; */
  width: 100%;
  background: linear-gradient(180deg, #f3ede4 0%, #ffffff 38.22%);

  .action-buttons {
    display: flex;
    align-items: center;
    gap: 5px;
    button {
      font-size: 12px;
      line-height: 150.5%;
      color: #1d1d1d;
      padding: 5px 10px;
      border: 1px solid #636f7c;
      border-radius: 30px;
      display: flex;
      align-items: center;
      min-width: 72px;
      min-height: 31px;
      gap: 5px;
      background-color: #fff;
      font-family: "latobold";
      text-transform: inherit;
      justify-content: center;

      &.active {
        background: #bc9b6a;
        color: #fff;
        border-color: transparent;
      }
      &.disabled {
        pointer-events: none;
        cursor: default;
        color: rgba(0, 0, 0, 0.26);
      }
    }
  }
  .heading {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #cdcfd0;
    h2 {
      font-weight: 500;
      font-size: 16px;
      line-height: 150.5%;
      padding-right: 30px;
      padding-bottom: 7px;
      border-bottom: 2px solid #bc9b6a;
      .setting-icon-wrapper {
        background: linear-gradient(180deg, #ececec 0%, #ffffff 100%);
        border: 1px solid #b5b5b5;
        border-radius: 5px;
        height: 24px;
        width: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 6px;
      }
    }
  }
  .MuiDialogContent-root {
    padding: 20px 0;
  }
  .group-btn-wrapper {
    display: inline-flex;
    align-items: center;
    border: 1px solid #bc9b6a;
    border-radius: 6px;
    overflow: hidden;
    background-color: #fff;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      line-height: 150.5%;
      min-width: 64px;
      padding: 0 11px;
      color: #1d1d1dcc;
      border: none;
      height: 30px;
      background-color: #fff;
      width: 100%;

      &.active {
        background: #bc9b6a;
        border-radius: 6px;
        color: #fff;
      }
    }
  }
  .select-wrapper {
    display: grid;
    grid-template-columns: 137px 1fr;
    align-items: center;
    gap: 4px;
    margin-bottom: 10px;
    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 150.5%;
      text-align: right;
    }
    .MuiSelect-select {
      padding: 3.5px 14px;
      font-size: 14px;
    }
  }
  .admin-only {
    display: grid;
    grid-template-columns: 137px 1fr;
    align-items: flex-start;
    gap: 4px;
    > p {
      font-size: 14px;
      line-height: 150.5%;
      text-align: right;
      font-weight: 500;
      margin-top: 6px;
    }
    .checkbox-wrapper {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      padding: 0 10px;
      margin-bottom: 10px;
      min-height: 35px;
    display: flex;
    align-items: center;
    gap: 9px;
      .MuiFormControlLabel-label {
        font-size: 14px;
      }
      &.active {
        background: linear-gradient(180deg, #8db5ff 0%, #4088cf 100%);
        border-radius: 6px;
        .MuiFormControlLabel-label {
          color: #fff;
        }
      }
    }
    .for-admin-only {
      background: linear-gradient(180deg, #8db5ff 0%, #4088cf 100%);
      padding: 0px 16px;
    }
  }
  .assigned-manifest {
    display: grid;
    grid-template-columns: 137px 1fr;
    align-items: center;
    gap: 4px;
    background: #c6dff9;
    min-height: 52.64px;
    button {
      background: linear-gradient(180deg, #f9f9f9 0%, #c6e1fd 100%);
      border: 1px solid #77a6d7;
      border-radius: 6px;
      height: 30px;
      width: 101.52px;
    }
    > p {
      font-size: 14px;
      line-height: 150.5%;
      text-align: right;
      font-weight: 500;
    }
  }
  .MuiDialogActions-root {
    justify-content: center;
    padding: 0;
    button {
      font-weight: 400;
      font-size: 14px;
      line-height: 150.5%;
      padding: 5px 20px;
      border: 1px solid #636f7c;
      border-radius: 30px;
      background-color: #fff;
    }
  }
  @media (max-width:400px) {
    .select-wrapper,.admin-only {
      grid-template-columns: 1fr;
      p {
        text-align: left;
      }
    }
  }
`;

export {
  Container,
  TagsWrapper,
  ActionWrapper,
  Tag,
  SettingIconWrapper,
  KeyIconWrapper,
  KeyPopup,
  ChangeSettingModalWrapper,
};
